module.exports = __webpack_public_path__ + "static/media/29EUNOG17.f67028f8.jpg";